import type { SVGProps } from 'react'

/** Stroke weight padrão para ícones de UI (nav, header, ações). */
export const CF_ICON_STROKE = 1.75

type IconSvgProps = SVGProps<SVGSVGElement> & { 'aria-hidden'?: boolean }

/** Props base para SVGs inline de chrome — não usar em gráficos/dados. */
export function cfIconSvgProps(size = 24): IconSvgProps {
  return {
    width: size,
    height: size,
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: CF_ICON_STROKE,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    'aria-hidden': true,
  }
}
